// extracted by mini-css-extract-plugin
module.exports = {"removeIconForKidsList":"Bw","removeIcon":"Bx wE"};